export default "__VITE_ASSET__DAKwDwcf__"